import enquiryForm from '../shared/enquiry-form';

export default {
  loaded() {
    enquiryForm()
  }
};
